import React, { useState, useEffect } from 'react';
import * as s from './styled-admin';
import { Loader, Button } from '../../components';
import { listUsers, validateUser, deleteUser } from '../../services';

export default () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    buscaUsuarios();
  }, []);

  const buscaUsuarios = () => {
    listUsers()
      .then((data) => {
        const formatedUsers = data.Users.map((user) => {
          return { ...user.Attributes.pop(), username: user.Username };
        });
        if (!formatedUsers.length) {
          setError('Não há usuários para serem validados');
        }
        setUsers(formatedUsers);
      })
      .catch(() => {
        setError('Não foi possível listar os usuários');
      })
      .finally(() => setLoading(false));
  };

  const confirmUser = (Username) => {
    validateUser(Username)
      .then(() => {
        buscaUsuarios();
      })
      .catch(() => {
        setError('Não foi possível validar o usuário');
        setLoading(false);
      });
  };

  const rejectUser = (Username) => {
    deleteUser(Username)
      .then(() => {
        buscaUsuarios();
      })
      .catch(() => {
        setError('Não foi possível validar o usuário');
        setLoading(false);
      });
  };

  return (
    <s.Container>
      <label>{error}</label>
      <s.ListWrapper>
        {loading ? (
          <s.LoaderWrapper>
            <Loader />
          </s.LoaderWrapper>
        ) : (
          users.map((user) => (
            <s.Line key={user.username || user.Value}>
              <s.EmailLabel>{user.Value}</s.EmailLabel>
              <s.ButtonsWrapper>
                <Button
                  width="125px"
                  label="Aceitar"
                  onClick={() => {
                    setLoading(true);
                    confirmUser(user.username);
                  }}
                />
                <Button
                  width="125px"
                  label="Rejeitar"
                  onClick={() => {
                    setLoading(true);
                    rejectUser(user.username);
                  }}
                />
              </s.ButtonsWrapper>
            </s.Line>
          ))
        )}
      </s.ListWrapper>
    </s.Container>
  );
};
